<template>
  <div class="proposed-shipment-shipping-point">
    <InfoIcon
      v-if="!shippingPoint?.location.locationName"
      icon="pi pi-exclamation-triangle"
      :tooltip="tooltip"
    />
    <ShippingPointSearchResult :shipping-point="shippingPoint" />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentStopType } from '@/model';
import { ProposedShipmentStop } from '@/model/routeBuilder';
import { RoutePlanStop } from '@/model/routeBuilder/phase2';

import ShippingPointSearchResult from '@/components/search/ShippingPointSearchResult.vue';
import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';

const props = defineProps({
  shippingPoint: {
    type: Object as PropType<ProposedShipmentStop | RoutePlanStop>,
    default: () => undefined,
  },
});
const { shippingPoint } = toRefs(props);

const { t } = useI18n();

const isPickup = computed(() => {
  return shippingPoint?.value?.stopType === ShipmentStopType.PICKUP;
});

const tooltip = computed(() => {
  return isPickup.value
    ? t('routeBuilder.missingOrigin')
    : t('routeBuilder.missingDestination');
});
</script>

<style>
.proposed-shipment-shipping-point {
  display: flex;
  gap: var(--sp-2);
  align-items: center;

  .info-icon-container {
    color: var(--warning-color);
  }
}
</style>
